import LoadFailure from '../../components/Brand/LoadFailure';
import './index.scss';
import usePageLayout from '../../hooks/usePageLayout';
import React, { useState, useEffect, useRef } from 'react';
import { Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import WiwHeaderTitle from '../../components/WiwHeaderTitle';
import BrandLoader from '../../components/Brand/BrandLoader';
import { Helmet } from 'react-helmet';
import { APP_ROUTES } from '../../utils/constant';
import url from '../../utils/url';
import api from '../../services';
import parse from 'html-react-parser';

const { Header, Content } = Layout;

export default function Static() {
  const headerRef = useRef(null);
  const { contentHeight, contentTop } = usePageLayout(headerRef);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { url: pageUrl } = useParams();
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState({ key: null, loading: true, error: false, page: null });
  // Hide the previous document immediately, before the next effect starts.
  const current = result.key === pageUrl ? result : { loading: true, page: null };
  const title = current.page?.title || '';

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setResult({ key: pageUrl, loading: true, error: false, page: null });
    const load = async () => {
      try {
        const response = await api.getPage({ url: pageUrl }, { signal: controller.signal });
        if (!active) return;
        if (response?.statusCode === 404 || (response?.success && !response.page)) {
          navigate(url(APP_ROUTES.PAGE404), { replace: true });
          return;
        }
        if (!response?.success || typeof response.page?.content !== 'string') throw new Error('Page unavailable');
        setResult({ key: pageUrl, loading: false, error: false, page: response.page });
      } catch {
        if (active) setResult({ key: pageUrl, loading: false, error: true, page: null });
      } finally {
        if (active) setResult(previous => ({ ...previous, loading: false }));
      }
    };
    load();
    return () => { active = false; controller.abort(); };
  }, [pageUrl, attempt, navigate]);

  return (
    <Layout className="app-layout static_page">
      <Helmet><title>{title}</title><meta name="description" content={title} /></Helmet>
      <Header className="header" ref={headerRef}><WiwHeaderTitle title={title} /></Header>
      <Content className="content-layot content-layout" style={{ height: contentHeight, top: contentTop }}>
        {current.loading ? <BrandLoader label={t('brand:loading')} /> : current.error ? (
          <LoadFailure onRetry={() => setAttempt(value => value + 1)} />
        ) : <div className="static-wrapper">{parse(current.page?.content || '')}</div>}
      </Content>
    </Layout>
  );
}
